var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43527",
    "data-name": "Group 43527",
    transform: "translate(-194 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16123",
    "data-name": "Rectangle 16123",
    width: 24,
    height: 24,
    transform: "translate(194 80)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1101",
    transform: "translate(195.5 764.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1103",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1105",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1111",
    transform: "translate(2.258 0.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    d: "M-259.672,0a8.241,8.241,0,0,0-8.242,8.242c0,6.154,8.242,11.538,8.242,11.538s8.242-5.385,8.242-11.538A8.241,8.241,0,0,0-259.672,0Z",
    transform: "translate(267.914)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1115",
    transform: "translate(5.578 4.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    d: "M0-103.385l4.922-3.281,4.922,3.281",
    transform: "translate(0 106.666)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1119",
    transform: "translate(9.27 9.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    d: "M0-77.539V-80H2.461v2.461",
    transform: "translate(0 80)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1123",
    transform: "translate(6.809 6.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    d: "M-232.617,0V5.331H-240V0",
    transform: "translate(239.999)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectPoint);
export default __webpack_public_path__ + "static/media/incorrect-point.3916aa6e3e428b774088af9ded8a23bc.svg";
export { ForwardRef as ReactComponent };